import styled from "styled-components";

export const BodyContainer = styled.div`
  display: flex;
  height: 100vh;
  flex-direction: column;
  align-self: stretch;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 0.5rem;
  padding-top: 10px;
  background: white;
  z-index: 3;
`;
